// src/pages/Login.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomLoader from "../components/CustomLoader";

import "../assets/css/login.css"; // move inline styles here if preferred

export default function Login() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Hide loader after 2 seconds
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    // optional: validate inputs or integrate auth logic here
    navigate("/dashboard");
  };

  return (
    <div className="login-page">
      {/* Custom Loader */}
      {isLoading && <CustomLoader />}

      {/* Back link */}
      <a href="/" className="back-button">← Go back</a>

      {/* Login Form */}
      <div className="form-container">
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input type="text" placeholder="Username" required />
          </div>
          <div className="form-group">
            <input type="password" placeholder="Password" required />
          </div>
          <button type="submit" className="btn">Login</button>
          <div className="form-footer">
            <p>
              Don't have an account? <a href="/register">Register now</a>
            </p>
          </div>
        </form>
      </div>

      {/* Page Lines */}
      <footer>
        <div className="page-lines">
          <div className="container">
            <div className="col-line col-xs-4"><div className="line"></div></div>
            <div className="col-line col-xs-4"><div className="line"></div></div>
            <div className="col-line col-xs-4">
              <div className="line"></div>
              <div className="line"></div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
